import { render, staticRenderFns } from "./faceAgreement.vue?vue&type=template&id=3063ca12&scoped=true"
import script from "./faceAgreement.vue?vue&type=script&lang=js"
export * from "./faceAgreement.vue?vue&type=script&lang=js"
import style0 from "./faceAgreement.vue?vue&type=style&index=0&id=3063ca12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063ca12",
  null
  
)

export default component.exports